<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page.sync="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   :search.sync="searchForm"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">
            <template slot="menuLeft">
                <addForm :projectId.sync="this.searchForm.projectId" @onload="onLoad"></addForm>
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                           plain
                           @click="moreDelete">删 除
                </el-button>
                           <!-- v-if="permission.taskimmediate_delete" -->

            </template>
            <template slot="menu" slot-scope="scope">
                <el-button type="text" icon="el-icon-view" @click="openViewDialog(scope.row)" >查看</el-button>
                
                <el-button slot="reference" type="text" icon="el-icon-delete" @click="deleteTask(scope.row)" v-if="scope.row.workStatus == 3">删除</el-button>
                
                
                <el-button type="text" icon="el-icon-edit" @click="openEditDialog(scope.row)" v-if="scope.row.workStatus == 0" >调整</el-button>
                <el-button type="text" icon="el-icon-circle-close" @click="shutDownTask(scope.row)" v-if="scope.row.workStatus == 0 || scope.row.workStatus == 1 || scope.row.workStatus == 5">关闭</el-button>
                
            </template>
        </avue-crud>
        <view-form ref="viewForm" style="display:none"></view-form>
        <editForm ref="editForm"></editForm>
    </basic-container>
</template>

<script>
        import {
                getDetail,
                update,
                
            } from "@/api/crmedical/device/task";
        import {
            getList,
            getProjectList,
            removeTask,
            closeTask
        } from "@/api/crmedical/device/taskManagement.js"
        import {mapGetters} from "vuex";
        import addForm from "./addForm.vue"
        import viewForm from "./viewForm.vue";
        import editForm from "./editForm.vue";
    export default {
            components:{addForm,viewForm,editForm},
        data() {
            return {
                form: {},
                searchForm:{projectId:''},
                query: {},
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                projectId:"",
                searchFlag:false,
                selectionList: [],
                option: {
                    height: 'auto',
                    calcHeight: 30,
                    tip: false,
                    searchMenuSpan: 24,
                    border: true,
                    index: true,
                    viewBtn: true,
                    selection: true,
                    align:'left',
                    searchMenuPosition:'right',
                    refreshBtn:true,
                    column: [
                                
                                {
                                    label: "项目名称",
                                    prop: "projectId",
                                    search:true,
                                    type:'select',
                                    searchClearable:false,
                                    
                                    dicData:[],
                                    searchValue:'',
                                    searchSpan:6,
                                    props:{
                                            label:'name',
                                            value:'id'
                                    },
                                    rules: [{
                                        required: true,
                                        message: "请选择项目",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "任务类型",
                                    prop: "type",
                                    search:true,
                                    type:"select",
                                    searchSpan:6,
                                    dataType:"string",
                                    props:{
                                            label:'dictValue',
                                            value:'dictKey',
                                    },
                                    dicUrl:'/api/blade-system/dict/dictionary?code=task_type',
                                    rules: [{
                                        required: true,
                                        message: "请选择任务类型",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "任务名称",
                                    prop: "name",
                                    search:true,
                                    maxlength:20,
                                    showWordLimit:true,
                                    type:"input",
                                    searchSpan:6,
                                    rules: [{
                                        required: true,
                                        message: "请输入任务名称",
                                        trigger: "change"
                                    }]
                                },
                                
                                {
                                        label: '开始时间',
                                        prop: 'validStartTime',
                                },
                                {
                                        label: '结束时间',
                                        prop: 'validEndTime',
                                        
                                },
                                // {
                                //     label: "执行日期",
                                //     prop: "executeDate",
                                //     searchPlaceholder:'请输入执行日期',
                                //     rules: [{
                                //         required: true,
                                //         message: "请输入执行日期",
                                //         trigger: "change"
                                //     }]
                                // },
                                
                                 
                                // {
                                //     label: "任务过期",
                                //     prop: "taskOverdueTimeNum",
                                //     rules: [{
                                //         required: true,
                                //         message: "请输入任务过期时限",
                                //         trigger: "change"
                                //     }]
                                // },
                                // {
                                //     label: "时间段",
                                //     prop: "timeQuantum",
                                //     rules: [{
                                //         required: true,
                                //         message: "请输入具体时间段，格式为hh:mm~hh:mm+d,hh:mm~hh:mm+d，其中hh:mm为小时分钟，d代表跨天天数",
                                //         trigger: "change"
                                //     }]
                                // },
                                {
                                    label: "计划人员",
                                    prop: "executeUserName",
                                    rules: [{
                                        required: true,
                                        message: "请输入任务人员",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "任务状态",
                                    prop: "workStatus",
                                    search:true,
                                    searchSpan:6,
                                    dataType:"string",
                                    props:{
                                            label:'dictValue',
                                            value:'dictKey',
                                    },
                                    dicUrl:'/api/blade-system/dict/dictionary?code=task_work_status',
                                    type:"select",
                                    rules: [{
                                        required: true,
                                        message: "请选择任务状态",
                                        trigger: "change"
                                    }]
                                },
                        ]
                        },
                        data: [],
                        projectList:[],


            };
        },
        watch:{
            "searchForm.projectId"(val){
                console.log(val)
                if(val){
                    this.projectId = val;

                }   
            }
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.taskimmediate_add, false),
                    viewBtn: this.vaildData(this.permission.taskimmediate_view, false),
                    delBtn: this.vaildData(this.permission.taskimmediate_delete, false),
                    editBtn: this.vaildData(this.permission.taskimmediate_edit, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            },
            
        },
        created(){
                this.initData();
                this.$nextTick(() => {
                        setTimeout(()=>{ 
                                console.log(this.$refs.crud.$children[1])
                                this.$refs.crud.$children[1].$children[5].$el.addEventListener("click", ()=>{
                                        
                                        if(this.option.height == this.bodyHeight - 370){
                                        this.option.height = this.bodyHeight - 280
                                        }else{
                                        this.option.height = this.bodyHeight - 370;
                                        }
                                        this.$refs.crud.getTableHeight();
                                });
                                })
                        
                        });
                        this.option.height = this.bodyHeight - 370;
        },
        methods: {
                // 多条删除
                moreDelete(){
                    if(this.selectionList.length<1){
                        this.$message({
                            message: '请先选择数据!',
                            type: 'warning'
                        });
                        return;
                    }
                    const h = this.$createElement;
                        this.$confirm('', '是否确定删除当前选择任务？', {
                            message:h('p', null, [
                                h('span', null, '删除说明: '),
                                h('p', { style: 'color: teal' }, '1、确认后将同步删除任务中的结果'),
                                h('p', { style: 'color: teal' }, '2、该操作不可逆，数据无法找回，请谨慎操作。')
                            ]),
                            icon:"none",
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                          
                        }).then(() => {
                            let id = "";
                            this.selectionList.forEach(ele=>{
                                id += ele.id + ",";
                            })
                            removeTask({ids:id}).then(res=>{
                                this.onLoad();
                                 this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            })
                           
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消删除'
                            });          
                        });
                },
                // 调整任务
                openEditDialog(row){
                    this.$refs.editForm.openDialog(row)
                },
                // 关闭任务
                shutDownTask(row){
                 
                        this.$confirm('是否确定关闭当前任务？', '提示', {
                           
                            type:"warning",
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                           
                        }).then(() => {
                            
                            console.log(row.id)
                            setTimeout(()=>{
                                closeTask({id:row.id}).then(res=>{
                                    this.onLoad();
                                    this.$message({
                                        type: 'success',
                                        message: '关闭成功!'
                                    });
                                })
                            },0)
                            
                           
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消关闭'
                            });          
                        });
                },
                // 删除任务
                deleteTask(row){
                        const h = this.$createElement;
                        this.$confirm('', '是否确定删除当前任务？', {
                            message:h('p', null, [
                                h('span', null, '删除说明: '),
                                h('p', { style: 'color: teal' }, '1、确认后将同步删除任务中的结果'),
                                h('p', { style: 'color: teal' }, '2、该操作不可逆，数据无法找回，请谨慎操作。')
                            ]),
                            icon:"none",
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                          
                        }).then(() => {
                            removeTask({ids:row.id}).then(res=>{
                                this.onLoad();
                                 this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            })
                           
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消删除'
                            });          
                        });
                },
                // 打开查看弹窗
                openViewDialog(id){
                    this.$refs.viewForm.openDialog(id);
                },
                // 初始化数据
                async initData(){
                        let projectColumn = this.findObject(this.option.column,'projectId');
                        // 获取项目
                        await getProjectList().then(res=>{
                                this.projectList = res.data;
                                projectColumn.dicData = res.data;
                                this.searchForm.projectId = this.projectList[0]?this.projectList[0].id:'';
                                this.searchFlag = true;
                                this.onLoad();
                        })
                        
                },
                // 新增临时任务
                addTemTask(){

                },
           
            rowUpdate(row, index, done, loading) {
                update(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                }
                done();
            },
            // 清空方法
            searchReset(...a) {
                    console.log(a)
                    // let projectId = this.projectList[0]?this.projectList[0].id:'';
                    this.searchForm.projectId = this.projectId
                    // this.searchForm.projectId = this.query.projectId;
                    this.query = {projectId:this.projectId};
                    this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                    if(!this.searchForm.projectId){
                            return;
                    }
                    !this.query.projectId?this.query.projectId=this.searchForm.projectId:'';
                    page = page || this.page;
                    this.loading = false;
                    getList(
                            Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                    ).then(({data}) => {
                            this.page.total = data.total;
                            this.data = data.records;
                            this.loading = false;
                            this.selectionClear();
                    });
            }
        }
    };
</script>
<style scoped>

  ::v-deep .avue-form__menu--center{
    text-align: right;
  }
::v-deep   .avue-crud__search .el-form-item--small.el-form-item{
    width: 100%;
  }
</style>
